import styled from '@olxeu-a2b/ui/src/theme/styled';
import {
  Paragraph3,
  Paragraph4,
  Paragraph6,
} from '@nexus/lib-react/dist/core/Typography/Paragraph';

const LabellessInfoBlock = styled.section`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: ${({ theme }) => theme.sizes.xl};

  > * {
    flex: 1 1 160px;
  }

  > figure {
    max-width: 48px;
    margin: 14px;
    margin-bottom: 30px;
  }
`;

const LabellessTitle = styled(Paragraph3)`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: ${({ theme }) => theme.fontWeights.bold};

  > * {
    margin-right: ${({ theme }) => theme.sizes.m};
  }
`;

const LabellessDescription = styled(Paragraph4)`
  color: ${({ theme }) => theme.colors.primary};
  margin-top: ${({ theme }) => theme.sizes.m};

  span::before,
  span::after {
    content: ' ';
    white-space: pre;
  }

  > span {
    color: ${({ theme }) => theme.colors['text-global-highlight']};
    font-weight: ${({ theme }) => theme.fontWeights.medium};

    &::before {
      content: ' ';
      white-space: pre;
    }

    &::after {
      content: ' ';
      white-space: pre;
    }
  }

  > a {
    color: ${({ theme }) => theme.colors['text-global-highlight']};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    text-decoration: none;

    &::before {
      content: ' ';
      white-space: pre;
    }

    &::after {
      content: ' ';
      white-space: pre;
    }
  }
`;

const MobileAppBlock = styled.aside`
  margin-block: ${({ theme }) => theme.sizes.m};
  > div {
    display: flex;
    flex-direction: row;
    column-gap: ${({ theme }) => theme.sizes.s};
  }
`;

const MobileAppLinksTitle = styled(Paragraph6)`
  margin-bottom: ${({ theme }) => theme.sizes.m};
`;

export default {
  LabellessInfoBlock,
  LabellessTitle,
  LabellessDescription,
  MobileAppBlock,
  MobileAppLinksTitle,
};
